import { useState } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { useTran } from "@/hooks";
import { User, Settings, LogOut, ChevronDown } from "lucide-react";
import { useAuthStore } from "@/features/auth/hooks";
import { PATHS } from "@/lib/router";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { resolveRoleLabel } from "@/features/user-management/utils/user-role-options";
import { Headset } from "lucide-react";

const UserMenu = observer(() => {
  const navigate = useNavigate();
  const { t } = useTran();
  const { user, logout, isJJSEA } = useAuthStore();
  const [open, setOpen] = useState(false);

  // Hide if not authenticated
  if (!user) return null;

  const handleLogout = async () => {
    setOpen(false);
    await logout();
  };

  const handleSettings = () => {
    setOpen(false);
    navigate(PATHS.SETTINGS);
  };
  const handleCallForHelp = () => {
    setOpen(false);
    navigate(PATHS.CALL_FOR_HELP);
  };

  const displayName = user.name || user.username || user.email;
  const roleName =
    resolveRoleLabel(user.role, t, undefined, user.customRoleName) ||
    t("Not available");
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex items-center gap-1 rounded-radius py-1 pl-1 pr-1.5 transition-colors hover:bg-muted sm:pr-2"
        >
          <div className="relative flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
            <User className="h-4 w-4 text-primary" />
          </div>
          <span className="hidden min-w-0 max-w-[12rem] flex-col text-left leading-tight md:flex">
            <span className="truncate text-sm font-medium">{displayName}</span>
            <span className="truncate text-xs text-muted-foreground">
              {roleName}
            </span>
          </span>
          <ChevronDown className="hidden h-4 w-4 md:block" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-48 max-w-[calc(100vw-1rem)]"
      >
        {/* <DropdownMenuItem onClick={handleProfile} className="cursor-pointer"> */}
        {/*   <User className="mr-2 h-4 w-4" /> */}
        {/*   <span>{t("Profile")}</span> */}
        {/* </DropdownMenuItem> */}
        <DropdownMenuItem onClick={handleSettings} className="cursor-pointer">
          <Settings className="mr-2 h-4 w-4" />
          <span>{t("User Settings")}</span>
        </DropdownMenuItem>
        {!isJJSEA && (
          <DropdownMenuItem
            onClick={handleCallForHelp}
            className="cursor-pointer"
          >
            <Headset className="mr-2 h-4 w-4" />
            <span>{t("Call For Help")}</span>
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleLogout}
          className="cursor-pointer text-red-600"
        >
          <LogOut className="mr-2 h-4 w-4" />
          <span>{t("Logout")}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
});

export default UserMenu;
